const locales = {
  CS_CZ: () => import('./cs_CZ.yml'),
  DA_DK: () => import('./da_DK.yml'),
  DE_AT: () => import('./de_AT.yml'),
  DE_CH: () => import('./de_CH.yml'),
  DE_DE: () => import('./de_DE.yml'),
  EL_GR: () => import('./el_GR.yml'),
  EN_CA: () => import('./en_CA.yml'),
  EN_GB: () => import('./en_GB.yml'),
  EN_US: () => import('./en_US.yml'),
  ES_ES: () => import('./es_ES.yml'),
  ES_MX: () => import('./es_MX.yml'),
  FI_FI: () => import('./fi_FI.yml'),
  FR_CA: () => import('./fr_CA.yml'),
  FR_CH: () => import('./fr_CH.yml'),
  FR_FR: () => import('./fr_FR.yml'),
  FR_BE: () => import('./fr_BE.yml'),
  IT_IT: () => import('./it_IT.yml'),
  IT_CH: () => import('./it_CH.yml'),
  NB_NO: () => import('./nb_NO.yml'),
  NL_NL: () => import('./nl_NL.yml'),
  NL_BE: () => import('./nl_BE.yml'),
  PL_PL: () => import('./pl_PL.yml'),
  PT_PT: () => import('./pt_PT.yml'),
  SV_FI: () => import('./sv_FI.yml'),
  SV_SE: () => import('./sv_SE.yml')
}

export const preffixFallbacks = {
  DA: 'DA_DK',
  DE: 'DE_DE',
  EN: 'EN_GB',
  ES: 'ES_ES',
  FI: 'FI_FI',
  FR: 'FR_FR',
  IT: 'IT_IT',
  NB: 'NB_NO',
  NL: 'NL_NL',
  PL: 'PL_PL',
  PT: 'PT_PT',
  SV: 'SV_SE'
}

export default locales
